export default {
  login_register: '登录/注册',
  booking_confirmation_title: '预订确认',
  booking_confirmation_body: '感谢您的预订。请在下面找到确认详细信息。',
  insurance_requirements_modal_disclaimer: `通过进行此预订，我确认: 在过去 5 年内，我没有任何犯罪记录或驾驶违法行为。我没有遇到过提案被拒绝、保单被取消或续保被拒绝、被要求支付增加的保费或被任何汽车保险公司施加任何特殊条件的情况。我没有被取消驾驶资格。我没有等待起诉或警方调查的情况。过去 5 年内，我没有任何与盗窃、欺诈或不诚实相关的犯罪记录。我没有患有视力或听力缺陷（未通过眼镜或助听器矫正）、心脏病、糖尿病、痉挛或任何类型的身体或精神疾病。过去 5 年里我没有发生过任何事故。如果您不符合这些要求，请点击{0}`,
  insurance_requirements_here: '这里',
  insurance_requirements: '我已阅读并理解 {0}',
  ir: '保险要求',
  location: '地点',
  pickup_location: '接送地点',
  dropoff_location: '还车地点',
  vehicle: '车辆',
  pickup_and_dropoff: '接送（当地时间）',
  view_voucher: '查看优惠券',
  identity_verification_body: '取车前您需要验证您的身份',
  identity_verification_title: '验证身份',
  search_again: '再次搜索',
  refrigerated: '冷藏的',
  aircon_lower: '空调',
  aircon: '空调',
  refrigeration: '冷藏',
  not_available: 'Drive & Go 目前仅适用于持有以下国家/地区身份和驾驶执照文件的人员。',
  check_if_included: '检查您的国家/地区是否包括在内。',
  included_in_booking: '包含在此预订中',
  cdw_with_excess: 'CDW 多余',
  theft_protection: '防盗保护过剩',
  risk_reduction: '降低风险',
  free_extras: '通过此次预订，您有权获得两项免费额外服务 <br />。',
  continue: '继续',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: '中号',
  luggage_small_short_label: 'S',
  luggage_large_long_label: '大的',
  luggage_medium_long_label: '中等的',
  luggage_small_long_label: '小的',
  fuel_unspecified_label: '未指定',
  transmission_manual_label: '手动的',
  transmission_automatic_label: '自动的',
  make_a_booking: '进行预订',
  pickup_date: '提货日期',
  dropoff_date: '还车日期',
  driver_age: '司机年龄在 30 - 65 岁之间',
  enter_driver_age: '请输入驾驶员年龄',
  promo_code: '促销代码',
  search: '搜索',
  dropoff_date_cannot_be_before_pickup_date: '还车日期不能早于取车日期',
  pickup_date_cannot_be_in_the_past: '取件日期不能是过去的日期',
  pickup_time_cannot_be_in_the_past: '取件时间不能是过去的时间',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: '如果是同一天，送机时间必须晚于接机时间',
  vehicle_filters: '车辆滤清器',
  reset: '重置',
  transmission: '传播',
  all: '全部',
  manual: '手动的',
  auto: '汽车',
  passengers: '乘客',
  vehicle_type: '车辆类型',
  filter: '筛选',
  vehicle_search: '车辆搜索',
  edit: '编辑',
  no_results: '没有结果符合您的过滤条件。',
  small_cars: '小型车',
  medium_cars: '中型车',
  large_cars: '大型车',
  estate_cars: '旅行车',
  suvs: 'SUV',
  mpvs: '多用途车',
  vans: '货车',
  camper_vans: '露营车',
  premium: '优质的',
  unspecified: '未指定',
  large: '大的',
  medium: '中等的',
  small: '小的',
  automatic: '自动的',
  you_have_been_refunded: '您已被退款。',
  please_customer_service: '如需预订，请联系我们的客户服务。',
  contact_customer_service: '联系客服',
  booking_failed: '这次无法处理您的预订。',
  summary: '概括',
  reforestation_and_protection: '支持哥斯达黎加各地的重新造林和保护雨林',
  cost_of_rental: '租金成本',
  to_pay_now: '立即付款',
  greenheart_donation: '绿心捐赠',
  total_cost: '总租金成本',
  tc_agreement: '我已阅读并理解{0}。',
  tc: 'T&Cs',
  receive_offers: '我希望通过电子邮件收到特别优惠。',
  donate: '是的，我想捐款 {amount}',
  pay_now: '立即支付{amount}',
  driver_details: '司机详细信息',
  complete_driver_details: '请填写司机的详细信息。',
  are_you_the_driver: '你是司机吗？',
  have_an_account: '您已经有帐户了吗？',
  login: '登录',
  or: '或者',
  first_name: '司机的名字',
  last_name: '司机姓氏',
  email: '电子邮件',
  phone_number: '手机号码',
  unable_to_save_driver_information: '无法保存驱动程序信息。请再试一次。',
  pay_online_now: '立即付款',
  day: '天',
  choose_location: '选择地点',
  location_not_found: '抱歉，我们无法找到您请求的位置。',
  add: '添加',
  remove: '消除',
  free_extra: '免费额外',
  free: '自由的！',
  fast_track_notice: '文件来源限制适用于此服务。它仅适用于持有以下文件的人',
  complete_booking: '完成预订',
  choose_card: '请选择一张卡或添加一张新卡。',
  add_billing_details: '请添加帐单详细信息。',
  card_number: '卡号',
  card_holder_name: '持卡人姓名',
  card_exp: '月/年',
  card_cvc: '中央VC',
  save_card: '存卡吗？',
  amount_charged: '您的卡将被扣款',
  payment_confirmation: '确认预订并付款',
  payment_methods: '可用的付款方式',
  use_saved_card: 'x 使用保存的卡',
  use_different_card: '+ 使用不同的卡',
  book_now: '立即预订',
  minimum_age: '超过{age}的唯一',
  excess_liability: '超额责任',
  security_deposit: '保证金',
  fuel_policy: '燃油政策',
  like_for_like: '喜欢又喜欢',
  full_to_full: '满到满',
  miles_per_rental: '{mileage} 每次租赁免费里程',
  km_per_rental: '{mileage} 每次租赁免费公里数',
  unlimited_mileage: '不限里程',
  unlimited_mileage_km: '无限公里',
  non_amendable: '不可修改',
  non_refundable: '不退还',
  free_cancellation_until: '免费取消直至',
  cancellation_in_line_with: '取消符合',
  tcs: 'T&amp;Cs',
  free_extras_on_collection: '收藏时可免费获得两项额外奖励',
  glass_and_tyres_covered: '玻璃和轮胎被覆盖',
  number_of_passengers: '乘客人数',
  number_of_bags: '袋数',
  fuel_type: '燃料类型',
  co2: 'CO2',
  book_type: '书{type}',
  processing: '加工',
  actual_price: '实际价格',
  tooltip: '{currencyCode} 中的价格是基于汇率的估算，{currency} 中的价格具有约束力。',
  deposit: '订金',
  pay_online: '立即付款',
  pay_online_without_extras: '租赁价格',
  extras_on_arrival: '抵达时的额外服务',
  insurance_on_arrival: '降低风险 - 抵达时付款',
  insurance_online: '降低风险 - 立即付款',
  extras_online: '立即支付额外费用',
  green_heart_donation: '绿心捐赠',
  why_use_drive_and_go: '为何使用 Drive & Go？',
  straight_to_car: '直接上车',
  no_queues: '无需排队',
  self_checkout: '自助结帐',
  cant_lose_key: '钥匙不能丢',
  online_id_check: '网上查身份证',
  phone_as_key: '电话当钥匙',
  premiumplus_benefits_includes: 'Premium Plus+ 还包括好处',
  book_drive_go: '预订驾车出行',
  distance_allowance: '距离津贴',
  duration: '期间',
  view_more_bookings: '查看更多预订',
  to_pay_on_arrival: '抵达时付款',
  pay_on_arrival: '抵达时付款',
  unlimited: '无限',
  return_date: '返回日期',
  postcode: '邮政编码',
  country: '国家',
  drive_and_go: {
    drive_and_go: '开车即走',
    available_countries: 'Drive &amp; Go 目前仅适用于持有来自以下国家/地区的身份和驾驶执照文件的人员:',
    drive_and_go_today: '立即驾车出行预订！',
    drive_and_go_shortened: '开车即走',
    why_use_drive_and_go: '为何使用 Drive & Go？',
    straight_to_car: '直接上车',
    no_queues: '无需排队',
    self_checkout: '自助结帐',
    cannot_lose_the_key: '钥匙不能丢',
    online_id_check: '网上查身份证',
    phone_as_a_key: '电话当钥匙',
    premium_plus_benefits_also_included: 'Premium Plus+ 还包括好处',
    book_drive_and_go: '预订驾车出行'
  },
  car_and_camp: {
    tent_and_equipment: "帐篷和装备",
    quick_and_easy: "快速轻松搭建",
    travel_freedom: "旅行自由",
    affordable_campervan_alternative: "经济实惠的房车替代方案",
    lightweight_and_compact: "轻便小巧",
    fully_insured: "全额保险",
  },
  my_bookings: "我的预订",
  no_bookings: "暂无预订",
  my_profile: '我的个人资料',
  no_bookings_to_display: '没有可显示的预订。',
  search_great_car_rental_deals: "为您的下次旅行搜索优质的汽车租赁优惠。",
  odometer_at_collection: '收集中的里程表',
  fuel_at_collection: '收集时的燃油',
  start_check_in: '开始办理登机手续',
  start_collection: '开始收集',
  recent_bookings: '最近预订',
  damage: {
    updated_damage_report_submitted: '已提交更新的损坏报告。如果需要，我们的客户服务团队成员将与您联系。',
    add_additional_damage: '增加额外伤害',
    you_may_report_additional_damage_up_to: '您可以在车辆结帐后 24 小时内报告额外损坏',
    specify_damage: '指定伤害',
    please_choose_the_area_and_type_of_damage: '请选择损坏的区域和类型',
    type_of_damage: '损坏类型',
    is_this_more_than_5_cm: '这超过5cm了吗？',
    please_take_or_select_a_photo: '请拍摄或选择一张照片',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: '请拍照以确保损坏清晰可见',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' 如果需要，您可以添加另一张照片，选择图标以添加另一张照片',
    save_image: '保存图像',
    save_images: '保存图像',
    damage_saved_successfully: '伤害已成功保存',
    add_photo: '添加照片'
  },
  checkout: {
    start_collection: '开始收藏',
    collect_vehicle: '收集车辆',
    we_will_let_you_know_the_details: '我们将告知您位置和详细信息，以便您找到租赁车辆。',
    inspect: '检查',
    we_will_ask_for_four_photos_from_each_corner: '我们将要求提供车辆每个角落的四张照片以及尚未列出的任何新损坏。',
    fuel_and_milage: '燃油和里程',
    you_confirm_the_readings_at_the_start_of_your_hire: '您在租赁开始时确认里程表和燃油读数。',
    sign: '符号',
    sign_the_rental_agreement: '签署租赁协议。',
    away_you_go: '走开你就走',
    you_are_free_to_take_to_the_road: '你可以自由地上路了！',
    collect_your_vehicle: '领取您的车辆',
    get_directions: '获取路线',
    hide_directions: '隐藏路线',
    local_time: '当地时间',
    tel: '电话',
    getting_to_the_location: '前往地点',
    get_vehicle_details: '获取车辆详细信息',
    view_map: '查看地图',
    unlock_vehicle_and_continue: '解锁车辆并继续',
    unable_to_connect_to_vehicle: '无法连接到车辆',
    we_were_unable_to_connect_to_the_vehicle_please_check: '我们无法连接到车辆 - 请检查您是否位于正确的车辆旁边，然后重试。',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: '我们无法找到车辆预订。请稍后重试。',
    odometer_and_fuel: '里程表和燃油',
    odometer: '里程表',
    please_confirm_the_odometer_and_fuel_readings: '如果可能，请确认里程表和燃油读数。',
    the_odometer_field_is_required: '里程表字段为必填项',
    and_must_be_greater_than_the_checkout_odometer: '& 必须大于退房里程表',
    confirm: '确认',
    please_take_a_photo_from_each_corner_of_the_vehicle: '请从车辆的各个角落拍摄照片',
    pre_existing_damage: '已有损坏',
    no_pre_existing_damage: '无预先存在的损坏。',
    new_damage: '新伤害',
    add_additional_damage: '增加额外伤害',
    no_new_damage_to_report: '没有新的损坏报告',
    checkout_complete: '结账完成',
    start_rental: '开始出租',
    congratulations_name_it_is_time_to_take_to_the_road: '恭喜{customer_name}，是时候上路了！',
    we_are_unable_to_complete_your_vehicle_checkout: '我们无法完成您的车辆结帐。',
    please_do_the_following: '请执行以下操作',
    remove_all_belonging_and_lock_the_vehicle: '移走所有物品并锁好车辆。',
    lock_vehicle: '锁车',
    once_you_have_contacted_customer_services: '联系客户服务后',
    vehicle_location: '车辆位置',
    collect_your: '收集你的',
    from: '从',
    key_in_glove_box: '您的钥匙位于手套箱中',

    keyholder: {
      not_detected: '钥匙扣中未检测到钥匙',
      not_detected_please_try_again: '请将钥匙放入钥匙扣中，然后重试。',

      not_installed: '钥匙扣未安装',
      not_installed_please_contact_customer_service: 'Keyholder未安装，请联系客服。',
    },
    keyring: {
      look_up_failed: '密钥环查找失败',
      look_up_failed_please_contact_customer_service: '钥匙扣查找失败，请联系客服。',
    },
    key: {
      invalid: '密钥无效',
      invalid_please_contact_customer_service: '您的密钥无效，请联系客服。',

      expired: '密钥已过期',
      expired__please_contact_customer_service: '您的密钥已过期，请联系客服。',
    }
  },
  checkin: {
    start_check_in: '开始办理登机手续',
    vehicle_location: '车辆位置',
    tell_us_where_you_have_parked: '告诉我们您把车停在哪里。',
    fuel_and_milage: '燃油和里程',
    you_confirm_the_readings_at_the_end_of_your_hire: '您在租赁结束时确认里程表和燃油读数。',
    inspect: '检查',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: '我们将要求提供车辆每个角落的四张照片以及租赁期间发生的任何新损坏。',
    lock: '锁',
    check_you_have_left_no_belonging_then_lock_the_vehicle: '检查您没有留下任何物品，然后锁上车辆。',
    please_tell_us_where_you_have_parked_the_vehicle: '请告诉我们您将车辆停放在哪里',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: '车辆一旦被锁定，您将无法再次解锁。',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}，请检查您没有留下任何物品，锁好车辆，如果需要，请将实体钥匙归还给钥匙持有人。',
    lock_vehicle: '锁车',
    complete_check_in: '完成登机手续',
    inspection: '检查',
    complete_vehicle_check_in: '完成车辆登记',
    we_are_unable_to_complete_your_vehicle_check_in: '我们无法完成您的车辆登记。',
    please_contact_customer_services: '请联系客服',
    once_you_have_contacted_customer_services: '联系客户服务后',
    please_amend_odometer_to_be_greater_than: '请将里程表修改为大于{odometer_value}',
  },
  rental_agreement: {
    rental_agreement: '租赁协议',
    agreement_between: '之间的协议',
    and: '和',
    sign_rental_agreement: '签订租赁协议',
    i_have_read_and_understood_the_terms_and_conditions: '我已阅读并理解条款和条件并接受车辆状况',
  },
  additional_options: '附加选项',
  booking_details: '预订详情',
  price_for_x_days: '{qty_of_days} 天的价格 | {qty_of_days} 天的价格',
  cancelled: '取消',
  upcoming: '即将推出',
  active: '积极的',
  full_insurance_no_deposit: '全额保险，无需押金',
  excess: '{amount} 多余',
  deposit: '{amount}存款',
  included_daily_distance: '每天 {distance} {unit}',
  miles: '英里',
  kilometers: '公里',
  collection_details_title: '收藏详情',
  collection_details_not_found: '没有为此位置定义集合详细信息',
  free_cancellation: '免费取消',
  no_deposit: '无押金',
  benefit_from: '受益于',
  for_only_per_day: '每天仅限 {price}',
  upgrade_mee: '升级我'
}
